module.exports = __webpack_public_path__ + "img/zhanli2.bb200632.jpg";